import { useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useCreateRole, usePermissionList } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';
import { getErrorMessage } from '../apiHelper';

function AddRole() {
	const history = useHistory();
	const { permissionList, loading: permissionsLoading } = usePermissionList();
	const [createRole, { loading: creating }] = useCreateRole();
	const { t } = useTranslation();
	const { setToastInfo } = useDashboardContext();
	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await createRole(values);
			setToastInfo?.({
  				message: t('notification.add.success', { name: 'Role' }),
				type: 'success',
				icon: 'check',
			});
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			const message = getErrorMessage(error, t("errorCodes.genericErrorMessage"));
			setToastInfo?.({
				message: message,
				type: 'warning',
				icon: 'campaignInfo',
			});
		}
	};

	if (permissionsLoading) return <Spin />;

	return (
		<>
			<PermissionList
				mode="add"
				permissionList={permissionList}
				loading={creating}
				onCancel={() => history.push(getAppRoutes().ROLES)}
				onSubmit={handleSubmit}
			/>
			
			</>
		
	);
}

export default AddRole;